<div class="h-6 absolute top-0 flex items-center justify-center" style="left: 100px" lohiPageTitle="Internal">
  <a routerLink="../" class="text-blue-500 text-xl mr-2 underline">Dashboard</a>
  <mat-form-field class="self-end">
    <mat-label>Shift ID</mat-label>
    <input #shiftIdInput matInput autocomplete="off" (keyup.Enter)="loadShift(shiftIdInput.value)" />
  </mat-form-field>
  <button mat-raised-button (click)="loadShift(shiftIdInput.value)">Load Map</button>
</div>
<div class="flex h-screen">
  <div style="width: 600px" class="flex h-screen">
    <div id="mouseMove" style="width: 200px" class="h-screen relative" (mousemove)="highlightWaypoint($event)">
      <div
        class="h-2 absolute pointer-events-none flex w-full text-sm"
        *ngFor="let hourMarker of hourMarkers; trackBy: 'time' | trackByKey"
        style="line-height: 16px"
        style.top="calc({{ hourMarker.locationPercent }}% - 8px)"
      >
        <div class="text-center text-gray-500" style="width: 175px">{{ hourMarker.time | standardDate }}<br /></div>
        <div class="flex-1 flex flex-col">
          <div class="h-1 flex-1 border-b border-gray-300"></div>
          <div class="h-1"></div>
        </div>
      </div>
      <div
        class="absolute"
        *ngFor="let shiftEventGroup of shiftEvents; trackBy: 'locationPercent' | trackByKey"
        style.top="{{ shiftEventGroup.locationPercent }}%"
        style.right="{{ shiftEventGroup.rightPx }}px"
      >
        <ng-template #tooltipContent>
          <div *ngFor="let shiftEvent of shiftEventGroup.shiftEvents" class="flex items-center even:bg-gray-800">
            <div class="w-3">
              <mat-icon
                class="cursor-default {{ shiftEvent.iconClass }}"
                style="transform: scale(0.5)"
                style="width: 12px; height: 12px"
                >{{ shiftEvent.iconName }}</mat-icon
              >
            </div>
            <div class="text-white w-25">{{ shiftEvent.time | standardDate }}</div>
            <div class="flex-1 text-left">{{ shiftEvent.message }}</div>
          </div>
        </ng-template>
        <div
          [tooltip]="tooltipContent"
          content-type="template"
          placement="right"
          class="cursor-default grid grid-cols-2 grid-rows-2 w-4 h-4"
        >
          <div class="flex items-center justify-center" *ngFor="let icon of shiftEventGroup.icons">
            <mat-icon class="{{ icon.className }}" style="transform: scale(0.8)">{{ icon.name }}</mat-icon>
          </div>
        </div>
        <!-- <mat-icon
          >list</mat-icon
        > -->
      </div>
      <div
        class="h-8 absolute pointer-events-none flex w-full text-sm"
        *ngIf="activeWaypoint"
        style="line-height: 16px"
        style.top="calc({{ activeWaypoint.locationPercent }}% - 32px)"
      >
        <div class="text-center flex flex-col" style="width: 176px">
          <div class="h-2 bg-yellow-500">
            {{ activeWaypoint.waypoint.timestamp | standardDate }}
            {{ activeWaypoint.waypoint.createdAt | standardTime }}
          </div>
          <div class="h-4 border-r border-yellow-500"></div>
          <div class="h-2 bg-yellow-500">({{ activeWaypoint.actualTime | standardDate }})</div>
        </div>
        <div class="flex-1 flex flex-col">
          <div class="h-4 flex-1 border-b-2 border-yellow-500"></div>
          <div class="h-4"></div>
        </div>
      </div>
    </div>
    <div class="relative flex-1">
      <div
        class="absolute border border-gray-700 w-full flex"
        *ngIf="beforeBox"
        style.top="{{ beforeBox.startPercent }}%"
        style.height="{{ beforeBox.height }}%"
      >
        <div class="w-3 h-full pt-1 truncate" style="writing-mode: vertical-lr">
          {{ beforeBox.name }}
        </div>
      </div>
      <div
        class="absolute border border-green-500 w-full flex"
        *ngIf="shiftBox"
        style.top="{{ shiftBox.startPercent }}%"
        style.height="{{ shiftBox.height }}%"
        (click)="highlightOrder($event, null)"
      >
        <div class="w-3 h-full pt-1 truncate" style="writing-mode: vertical-lr">
          {{ shiftBox.name }}
        </div>
      </div>
      <div
        class="absolute border border-gray-700 w-full flex"
        *ngIf="afterBox"
        style.top="{{ afterBox.startPercent }}%"
        style.height="{{ afterBox.height }}%"
      >
        <div class="w-3 h-full pt-1 truncate" style="writing-mode: vertical-lr">
          {{ afterBox.name }}
        </div>
      </div>
      <div *ngFor="let box of orderBoxes; trackBy: 'name' | trackByKey" (click)="highlightOrder($event, box.order.id)">
        <div
          class="absolute border-4 border-orange-500 flex flex-col pl-1 pr-1 overflow-hidden"
          [class.border]="box.order.id !== selectedOrderId"
          style="left: 24px; right: 0"
          style.top="{{ box.startPercent }}%"
          style.height="{{ box.height }}%"
        >
          <div class="font-bold">{{ box.name }} - {{ box.order.totalMinutesReal | prettyPrintMinutes }}</div>
          <div><span class="font-semibold">From:</span> {{ box.order.mineName }}</div>
          <div><span class="font-semibold">To:</span> {{ box.order.fracName }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-1 bg-blue-500">
    <lohi-shift-map-internal
      [highlightedOrderId]="selectedOrderId"
      [activeWaypoint]="activeWaypoint?.waypoint"
      class="h-screen w-full"
    ></lohi-shift-map-internal>
  </div>
</div>
